import Interview from './Interview'

export default Interview
